import * as React from "react";
import classnames from "classnames";
/* empty css          */
const variantMap = {
  body: "p",
  "body-head": "strong",
  caption: "small",
  "caption-head": "strong",
  link: "span",
  list: "span"
};
const Text = ({
  align = "inherit",
  className,
  color = "inherit",
  component,
  variant = "body",
  "data-t": testId = "typography-text",
  ...rest
}) => {
  const Component = component || variantMap[variant];
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      className: classnames("typography-text", `typography-text--${variant}`, className, {
        [`typography-text--align-${align}`]: align !== "inherit",
        [`typography-text--color-${color}`]: color !== "inherit"
      }),
      "data-t": testId,
      ...rest
    }
  );
};
export {
  Text as default
};
//# sourceMappingURL=Text.js.map
